import React, { useEffect, useState } from "react";
import "./Blog_Details.css";
import Common_Back_Header from "../common-components/common_back_header/Common_Back_Header";

import { useNavigate, useLocation } from "react-router-dom";
import { Blog, BlogById } from "../../utils/apis/blog/Blog";
import { IDS } from "../../utils/common";

const Blog_Details = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const blogId = location.pathname.split("/").pop();

  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);

  useEffect(() => {
    const getBlogDetails = async () => {
      try {
        const res = await BlogById(blogId);

        if (res?.success) {
          setBlog(res?.data);
        }
      } catch (error) {
        console.error("Error fetching blog details:", error);
      }
    };

    if (blogId) {
      getBlogDetails();
    }
  }, [blogId]);

  useEffect(() => {
    const getRecentBlogs = async () => {
      try {
        const res = await Blog();

        if (res?.success) {
          setRecentBlogs(res?.data || []);
        }
      } catch (error) {
        console.error("Error fetching recent blogs:", error);
      }
    };

    getRecentBlogs();
  }, []);

  // const recentBlogs = [
  //   {
  //     id: 1,
  //     title: "Tomato Nutrition Guide for Healthy Growth",
  //     image: "/assets/images/blogs/img1.webp",
  //     date: "03 Aug 2026",
  //   },
  //   {
  //     id: 2,
  //     title: "Best Fertilizers for Vegetable Crops",
  //     image: "/assets/images/blogs/vegetable.jpeg",
  //     date: "01 Aug 2026",
  //   },
  //   {
  //     id: 3,
  //     title: "How to Improve Soil Fertility Naturally",
  //     image: "/assets/images/blogs/vegetable.jpeg",
  //     date: "28 Jul 2026",
  //   },
  // ];

  return (
    <section className="Blog_Details">
      <div className="container">
        <div className="back">
          <Common_Back_Header />
        </div>

        <div className="blog_details_section">
          <div className="row">
            {/* Main Blog */}
            {/* <div className="col-lg-8 col-md-7"> */}
            <div
              className={
                recentBlogs.filter((item) => item.id !== Number(blogId))
                  .length > 0
                  ? "col-lg-8 col-md-7"
                  : "col-lg-12 col-md-12"
              }
            >
              <div className="blog_main">
                <h2 className="blog_main_title">
                  {/* Complete Tomato Nutrition Guide: Essential Nutrients for
                  Healthy Growth & Higher Yields */}
                  {blog?.title}
                </h2>

                <div className="blog_main_image_wrapper">
                  {/* <img
                    src="/assets/images/home/nutricos_banner/img1.webp"
                    alt="Tomato Nutrition"
                    className="blog_main_image"
                  /> */}
                  <img
                    src={IDS?.IMG_URL + blog?.image}
                    alt={blog?.name}
                    className="blog_main_image"
                  />

                  <div className="blog_image_overlay">
                    {/* <span>03 Aug 2026</span> */}
                    <span>
                      {blog?.createdAt
                        ? new Date(blog.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </span>
                    {/* <span>Views: 589</span> */}
                  </div>
                </div>

                <div className="blog_description">
                  <h4>Why Tomato Nutrition Matters</h4>

                  <div
                    className="blog_text"
                    dangerouslySetInnerHTML={{
                      __html: blog?.description || "",
                    }}
                  />

                  <h4>Conclusion: </h4>

                  {blog?.conclusion && (
                    <div
                      className="blog_text"
                      dangerouslySetInnerHTML={{
                        __html: blog.conclusion,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Recent Blogs */}
            <div className="col-lg-4 col-md-5">
              {recentBlogs.filter((blog) => blog.id !== Number(blogId)).length >
                0 && (
                <div className="recent_blog_sidebar">
                  <h5 className="recent_title">Recent Blogs</h5>

                  <div className="recent_blog_list">
                    {recentBlogs
                      .filter((blog) => blog.id !== Number(blogId))
                      .map((blog) => (
                        <div key={blog?.id} className="recent_blog_card">
                          <img
                            src={IDS?.IMG_URL + blog.image}
                            alt={blog?.name}
                            className="recent_blog_image"
                          />

                          <div className="recent_blog_overlay">
                            <h6 className="item_title">{blog?.name}</h6>

                            <div className="recent_footer">
                              <span
                                className="read_btn"
                                onClick={() => {
                                  console.log(blog);
                                  navigate(`/blog/${blog.id}`);
                                }}
                              >
                                Start Reading
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog_Details;
